import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface StatusProps {
  labels: {
    header: string;
    protectedForest: string;
    greenOperationsPlan: string;
    constraintsMap: string;
  };
  data: {
    protectedForest: string | null | undefined;
    greenOperationsPlan: string | null | undefined;
    constraintsMap: string | null | undefined;
  };
}

const Status = ({ labels, data }: StatusProps) => (
  <>
    <View style={styles.row}>
      <Text style={styles.subHeader}>{labels.header}</Text>
    </View>

    {(data.protectedForest !== undefined || data.greenOperationsPlan !== undefined || data.constraintsMap !== undefined) && <>
      <View style={styles.miniSpacer} />

      <View style={styles.row}>
        {data.protectedForest !== undefined && <Element label={labels.protectedForest} data={data.protectedForest} />}

        {data.greenOperationsPlan !== undefined && <Element label={labels.greenOperationsPlan} data={data.greenOperationsPlan} />}

        {data.constraintsMap !== undefined && <Element label={labels.constraintsMap} data={data.constraintsMap} />}

        {data.protectedForest === undefined && <View style={styles.column} />}
        {data.greenOperationsPlan === undefined && <View style={styles.column} />}
        {data.constraintsMap === undefined && <View style={styles.column} />}

        <View style={styles.column} />
      </View>
    </>}
  </>
);

export default Status;